import React from "react";
import JournalVoucher from './Journal_Voucher';

const JV_VchrApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Journal Voucher</h5>
          </div>
        </div>
        <JournalVoucher />
      </div>
    </div >
  );
};

export default JV_VchrApp;
